// DashboardProjectItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Progress from '../../common/progress_bar/progress_bar.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import DateUtil from '../../../lib/dateutil.jsx'

class DashboardProjectItem extends Component {
  static get propTypes () {
    return {
      project: PropTypes.object,
      onClick: PropTypes.func,
      useProjectNumber: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      project: null,
      onClick: null,
      useProjectNumber: false
    }
  }

  render () {
    const project = this.props.project
    const totalBudget =
      project.budget && project.budget.total ? project.budget.total : 0
    const totalSpent =
      project.budget && project.budget.totalSpent
        ? project.budget.totalSpent
        : 0
    const className = classnames('dashboard-projectitem', {
      late:
        project.budget && totalSpent && totalBudget && totalSpent > totalBudget,
      left:
        project.budget && totalSpent && totalBudget && totalSpent < totalBudget
    })

    let percentage =
      project.budget && project.budget.total && project.budget.totalSpent
        ? (project.budget.totalSpent / project.budget.total) * 100
        : 0
    percentage = parseInt(percentage.toFixed(0), 10)

    return (
      <div
        className={className}
        title={[
          this.props.useProjectNumber && project.projectNumber,
          project.title
        ]
          .filter(Boolean)
          .join(' / ')}
        onClick={this._onClick.bind(this)}
      >
        <h3 className='title'>
          {[this.props.useProjectNumber && project.projectNumber, project.title]
            .filter(Boolean)
            .join(' / ')}
        </h3>
        {project.contact && (
          <div className='client' title={project.contact.company}>
            {project.contact.company}
          </div>
        )}
        {this._renderdeadLine()}
        <Progress
          value={percentage}
          mode='determinate'
          max={100}
          buffer={100}
          type='linear'
        />
      </div>
    )
  }

  /* Private Function */
  _onClick (e) {
    e.preventDefault()

    if (this.props.onClick) {
      this.props.onClick(this.props.project)
    }
  }

  _renderdeadLine () {
    const project = this.props.project
    const deadline = project.endDate ? new Date(project.endDate) : ''
    const totalBudget =
      project.budget && project.budget.total ? project.budget.total : 0
    const totalSpent =
      project.budget && project.budget.totalSpent
        ? project.budget.totalSpent
        : 0

    if (project.budget && totalSpent && totalBudget) {
      if (totalSpent > totalBudget) {
        // Check total spent with with budget
        return (
          <div className='deadline-budget'>
            {this._renderDeadlineDate(deadline)}
            <div className='split' />
            <div className='overbudget'>
              <IntlMessage ident='common.dashboard.labelOverBudget' />
            </div>
          </div>
        )
      }
    }

    return this._renderDeadlineDate(deadline)
  }

  _renderDeadlineDate (deadline) {
    if (deadline && deadline > DateUtil.getUTCCurrentDate()) {
      // Check deadline is greater and calculate Date left
      return (
        <div className='deadline'>{DateUtil.displayHumanized(deadline)}</div>
      )
    } else if (deadline && deadline < DateUtil.getUTCCurrentDate()) {
      // Check deadline is smaller and calculate Date late
      return (
        <div className='deadline'>{DateUtil.displayHumanized(deadline)}</div>
      )
    }
    // Return "No Deadline" if there is no deadline
    return (
      <div className='nodeadline'>
        <IntlMessage ident='common.dashboard.labelNoDeadLine' />
      </div>
    )
  }
}

export default DashboardProjectItem
